<template>
    <div class="wrapper starter-page">
        <h2 class="text-center">Simple way to find required beat length</h2>
        <div class="d-flex justify-content-between flex-wrap-reverse">
            <div class="d-flex flex-wrap flex-row justify-content-around col-lg-8 col-md-12">
                <div>
                    <div class="info info-hover">
                        <div class="icon icon-success icon-circle">
                            <i class="far fa-flag"></i>
                        </div>
                        <h4 class="info-title">22 Classes</h4>
                        <p class="description">Speed data from covering over 20 classes in different conditions</p>
                    </div>
                </div>

                <div>
                    <div class="info info-hover">
                        <div class="icon icon-info icon-circle">
                            <i class="far fa-draw-polygon"></i>
                        </div>
                        <h4 class="info-title">20 layouts</h4>
                        <p class="description">Choose Windward/Leeward, Triangular or Trapezoidal course with different Start/Finish options. Adjust angle and number of beats.</p>
                    </div>
                </div>

                <div>
                    <div class="info info-hover">
                        <div class="icon icon-primary icon-circle">
                            <i class="far fa-sync"></i>
                        </div>
                        <h4 class="info-title">Automatic recalculation</h4>
                        <p class="description">Enter elapsed time after a leg and get updated finish time/new beat length suggestion.</p>
                    </div>
                </div>

                <div>
                    <div class="info info-hover">
                        <div class="icon icon-success icon-circle">
                            <i class="far fa-copy"></i>
                        </div>
                        <h4 class="info-title">Multiple tracks</h4>
                        <p class="description">Keep track of multiple races at the same time or just prepare for the next race.</p>
                    </div>
                </div>

            </div>
            <div class="col-lg-4 col-md-12">
                <div class="d-flex flex-column" style="padding: 20px;">
                    <img class="screenshot" src="/images/BeatLength-Started.png" alt="Main Screen" v-rjs="3" style="max-width: 100%; height: auto"/>

                    <a class="d-block text-center"
                       href="https://apps.apple.com/app/beat-length-calculator/id1635014077?mt=8">
                        <img style="height: 60px" src="/images/Download_on_the_App_Store.svg" alt="App Store"/>
                    </a>
                    <a class="d-block text-center" href='https://play.google.com/store/apps/details?id=info.leonenko.beatlengthcalculator.android'>
                      <img style="height: 80px" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                    </a>
                </div>
            </div>
        </div>

      <div class="col-lg-8 col-md-12">
        <h3 id="sources">Data Sources</h3>
        <ul>
          <li>David Campbell-James: <a href="https://www.rya.org.uk/racing/running-racing/speed-charts">Multiple classes</a></li>
          <li>International Kiteboarding Association: <a href="https://formulakite.org/about/for-organizers/speed-charts">Formula Kite</a></li>
          <li>Offshore Racing Congress: <a href="https://orc.org/organization/monohulls/orc-one-design-certificates">Multiple classes</a></li>
        </ul>
      </div>
    </div>
</template>
<script>
    export default {
        components: {

        }
    }
</script>
<style lang="scss" scoped>
    .starter-page {
        min-height: calc(100vh - 159px);
    }

    .store-badge {
      height: 60px;
        //max-width: 300px;
    }

    .screenshot {
        margin: 0 0 25px;
    }
</style>
